import { Request } from 'express';
import { JwtPayload } from 'aws-jwt-verify/jwt-model';
import { AppTypes } from '../apps/apps.types';
import { UserType } from '../cognito/user.types';
import { RestaurantResponseType } from '../restaurant/restaurant.types';
import { RecordStatus } from '../menu/enums.types';

export type JwtPayloadExtended = {
  restaurantId?: number;
  sub?: string;
  businessId?: number;
  appType: AppTypes;
  userType: UserType;
  username?: string;
  tenantName?: string;
  deviceId?: string;
  employeeId?: string;
  isMpos?: boolean;
};
export interface RequestWithUser extends Request {
  payloadData: JwtPayload & JwtPayloadExtended;
}

export interface RoleType {
  name: string;
  restaurant: RestaurantResponseType;
}

export enum RoleTag {
  BOH = 'BOH',
  FOH = 'FOH',
  MANAGER = 'Manager',
}

export enum RequestFrom {
  POS = 'POS',
  MOM = 'MOM',
  ONLINE = 'ONLINE',
}
export interface RoleRequestType {
  name: string;
  restaurantId: number;
  tags?: RoleTag[];
}

export interface RoleDataResponse {
  id: number;
  roleName: string;
  status: RecordStatus;
  createdAt: Date;
  updatedAt: Date;
}

export enum RoleTypeKeys {
  AIO_IT = 'aio-it',
  OWNER = 'owner',
  GENERAL_MANAGER = 'general-manager',
  SHIFT_OR_ASSISTANT_MANAGER = 'shift-or-assistant-manager',
  BARBACK = 'barback',
  MANAGER = 'manager',
  BARTENDER = 'bartender',
  SERVER = 'server',
  DELIVERY_SERVICE_DRIVER = 'delivery-service-driver',
  LINE_COOK = 'line-cook',
  COOK = 'cook',
  BUSSER = 'busser',
  DISHWASHER = 'dishwasher',
  JANITORIAL = 'janitorial',
  CASHIER = 'cashier',
  BUDDY = 'buddy',
}
